export const LANDING = '/';
export const ALLCHARACTERS = '/characters';
